module.exports = {"id":"212523","name":"Anderson Talisca","rating":"81","photo":"./data/images/photos/4/212523.png","club":{"name":"Beşiktaş","logo":"./data/images/clubs/Besiktas.png"},"positions":["MOC","BU","MC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AndersonTalisca0.json
// module id = 326
// module chunks = 0